<template>
  <div class="kv-ve__group">
    <div class="form-row">
      <div class="form-group col-6">
        <label>{{ $_("visualEditor-emailEditor-common-color") }}</label>
        <VeColorPicker v-model="block.settings.color" />
      </div>
      <div class="form-group col-6">
        <label>{{ $_("visualEditor-emailEditor-common-thickness") }}</label>
        <input class="form-control" type="number" v-model.number="block.settings.thickness" min="1" />
      </div>
    </div>

    <div class="form-group">
      <div style="display:flex; align-items:center; justify-content:space-between; gap:10px; margin-bottom:8px;">
        <div style="display:flex; align-items:baseline; gap:6px;">
          <label style="margin:0;">{{ $_("visualEditor-emailEditor-common-width") }}</label>
          <VeWidthUnitToggle
            v-model="widthModeProxy"
            :label="$_('visualEditor-emailEditor-common-width')"
            pctTitle="%"
            pxTitle="px"
          />
        </div>
        <div style="display:flex; align-items:center; gap:8px;">
          <input
            v-if="widthModeProxy === 'pct'"
            class="form-control"
            type="number"
            v-model.number="widthPctProxy"
            min="10"
            max="100"
            style="width: 88px; height: 34px; padding: 6px 10px; font-size: 12px; font-variant-numeric: tabular-nums;"
          />
          <input
            v-else
            class="form-control"
            type="number"
            v-model.number="widthPxProxy"
            min="0"
            max="600"
            style="width: 88px; height: 34px; padding: 6px 10px; font-size: 12px; font-variant-numeric: tabular-nums;"
          />
          <div style="font-size:12px; font-variant-numeric: tabular-nums; color:#667085;">
            {{ widthModeProxy === 'pct' ? '%' : 'px' }}
          </div>
        </div>
      </div>
      <VeWidthSlider
        v-if="widthModeProxy === 'pct'"
        v-model="widthPctProxy"
        :label="$_('visualEditor-emailEditor-common-width')"
        :min="10"
        :max="100"
        :step="1"
        unit="%"
        :showHeader="false"
      />
      <VeWidthSlider
        v-else
        v-model="widthPxProxy"
        :label="$_('visualEditor-emailEditor-common-widthPx')"
        :min="0"
        :max="600"
        :step="10"
        unit="px"
        :showHeader="false"
      />
    </div>

    <VeBlockMarginsSettings :block="block" />

  </div>
</template>

<script>
import VeWidthSlider from "../../components/VeWidthSlider.vue";
import VeWidthUnitToggle from "../../components/VeWidthUnitToggle.vue";
import VeBlockMarginsSettings from "../VeBlockMarginsSettings.vue";
import VeColorPicker from "../../components/VeColorPicker.vue";

export default {
  name: "VeDividerBlockSettings",
  components: { VeWidthSlider, VeWidthUnitToggle, VeBlockMarginsSettings, VeColorPicker },
  props: {
    block: { type: Object, required: true },
    paletteLabel: { type: String, required: true },
  },
  computed: {
    widthModeProxy: {
      get() {
        const v = String(this.block?.settings?.widthMode || "").toLowerCase();
        return v === "px" ? "px" : "pct";
      },
      set(next) {
        const v = String(next || "").toLowerCase();
        const safe = v === "px" ? "px" : "pct";
        if (!this.block.settings) this.$set(this.block, "settings", {});
        this.$set(this.block.settings, "widthMode", safe);
      },
    },
    widthPctProxy: {
      get() {
        const n = Number(this.block?.settings?.widthPct);
        if (!Number.isFinite(n)) return 100;
        return Math.min(100, Math.max(10, Math.round(n)));
      },
      set(v) {
        const n = Number(v);
        const next = Number.isFinite(n) ? Math.min(100, Math.max(10, Math.round(n))) : 100;
        if (!this.block.settings) this.$set(this.block, "settings", {});
        this.$set(this.block.settings, "widthPct", next);
      },
    },
    widthPxProxy: {
      // 0 means "auto"
      get() {
        const n = Number(this.block?.settings?.widthPx);
        if (!Number.isFinite(n)) return 0;
        return Math.min(600, Math.max(0, Math.round(n)));
      },
      set(v) {
        const n = Number(v);
        const next = Number.isFinite(n) ? Math.min(600, Math.max(0, Math.round(n))) : 0;
        if (!this.block.settings) this.$set(this.block, "settings", {});
        this.$set(this.block.settings, "widthPx", next);
      },
    },
  },
  methods: {
  },
};
</script>


